import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarText,
  NavbarToggler,
  NavLink,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ReactComponent as Logo } from 'assets/images/svg/logo.svg';
import styles from "./style.module.scss";
import { getUserData } from "utils/Session";
import CalculatorOffCanvas from "components/OffCanvas/CalculatorOffCanvas";
import ReferalOffCanvas from "components/OffCanvas/ReferalOffCanvas";
import { getPOBoxByUser } from "api/POBoxApi";

const UserNavMenu = props => {
  const USER_PATH_PREFIX = "/user"
  const navigate = useNavigate();
  const location = useLocation();
  const isUserPath = location.pathname.startsWith(USER_PATH_PREFIX);
  const [isOpen, setIsOpen] = useState(false);

  const [userData, setUserData] = useState({});
  const [poBox, setPOBox] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    getUserName();
  }, [])

  const getUserName = async () => {
    const userData = await getUserData();
    if (userData) {
      const poBox = await getPOBoxByUser(userData);
      setUserData(userData?.attributes || {});
      setPOBox(poBox || {});
    }
  }

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      {isUserPath && (
        <Navbar
          className={styles.mainNav}
          expand="md"
          light
        >
          <NavbarBrand className="col-4 col-sm-2" href="/user/dashboard">
            <Logo className={styles.logo} />
          </NavbarBrand>
          <NavbarToggler className={styles.toggler} onClick={toggle} />
          <Collapse isOpen={isOpen} className={styles.navBar} navbar>
            <Nav
              className="me-auto"
              navbar
            >
              <NavItem>
                <NavLink href="#" onClick={(e) => navigate("/user/dashboard")}>
                  Paquetes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" onClick={(e) => navigate("/user/profile")}>
                  Mi Perfil
                </NavLink>
              </NavItem>
              <NavItem>
                <CalculatorOffCanvas
                  wrapper={NavLink}>
                  Calculadora
                </CalculatorOffCanvas>
              </NavItem>
              {/* <NavItem>
                <ReferalOffCanvas
                  poBox={poBox}
                  wrapper={NavLink}>
                  Referir Amigos
                </ReferalOffCanvas>
              </NavItem> */}
            </Nav>
            <NavbarText>
              <Nav
                navbar
              >
                <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle className={styles.dropdownToggle} nav caret>
                    <AccountCircleIcon className={styles.profileIcon} />
                    {userData.name || ""}
                  </DropdownToggle>
                  <DropdownMenu className={styles.dropdownMenu}>
                    <DropdownItem>
                      <NavLink href="#" onClick={(e) => navigate("/auth/logout")}>
                        Cerrar Session
                      </NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Nav>
            </NavbarText>
          </Collapse>
        </Navbar >
      )}
    </>
  );
}
export default UserNavMenu;